export default {
  active: 'Ativo',
  paused: 'Pausado',
  completed: 'Concluído',
  failed: 'Com falha',
  disabled: 'Desativado',
};
